import { ThemeProvider, LocalizationProvider } from '@smgl/ui-kit';
import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from '~/shared/api/query-client';
import i18n from '~/shared/lib/i18n';

import { InitProvider } from './providers/InitProvider/InitProvider';
import { RouterProvider } from './providers/RouterProvider/RouterProvider';
import { PaymentStepProvider } from './providers/paymentStepProvider/paymentStepProvider';

export const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider storageKey="gift-card-bot-theme" defaultTheme="dark">
      <LocalizationProvider i18nInstance={i18n} initialLanguage="ru">
        <InitProvider>
          <PaymentStepProvider>
            <RouterProvider />
          </PaymentStepProvider>
        </InitProvider>
      </LocalizationProvider>
    </ThemeProvider>
  </QueryClientProvider>
);
